// extracted by mini-css-extract-plugin
export default {"contents":"iE-z","sectionHeading":"jE-z"};